import React from 'react';
import styles from './StatusDot.module.scss';
import { OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';

type Props = {
  opportunity: OneWayInOpportunitySimpleV2Dto;
};

const StatusDot = ({ opportunity }: Props) => {
  return <div className={`${styles.dot} ${styles[opportunity.status?.status || '']}`}></div>;
};

export default StatusDot;
